
export default [
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    component: 'CNavTitle',
    name: 'Database',
  },
  {
    component: 'CNavItem',
    name: 'Concept',
    to: '/concept',
    icon: 'cil-folder',
  },
  {
    component: 'CNavItem',
    name: 'Networks Log',
    to: '/concept-networks',
    icon: 'cil-grid',
  },
  {
    component: 'CNavItem',
    name: 'Apps',
    to: '/apps',
    icon: 'cil-gamepad',
  },
  {
    component: 'CNavItem',
    name: 'New Number',
    to: '/naming/create',
    icon: 'cil-pencil',
  },
  {
    component: 'CNavItem',
    name: 'Playables Live',
    to: '/playables/live',
    icon: 'cil-media-play',
  },
  {
    component: 'CNavItem',
    name: 'Creative Log',
    to: '/creative-log',
    icon: 'cib-libreoffice',
  },
  {
    component: 'CNavItem',
    name: 'Charts & Diagrams',
    to: '/creative-charts',
    icon: 'cil-chart-pie',
  },
  {
    component: 'CNavTitle',
    name: 'Network',
  },
  {
    component: 'CNavItem',
    name: 'AppLovin',
    to: '/network/applovin',
    icon: 'cil-puzzle',

  },
  {
    component: 'CNavItem',
    name: 'Google Ads',
    to: '/network/google-ads',
    icon: 'cil-puzzle',

  },
  {
    component: 'CNavItem',
    name: 'Facebook Ads',
    to: '/network/facebook-ads',
    icon: 'cil-puzzle',
  },
  {
    component: 'CNavItem',
    name: 'Mintegral',
    to: '/network/mintegral',
    icon: 'cil-puzzle',
  },
  {
    component: 'CNavItem',
    name: 'Unity Ads',
    to: '/network/unity-ads',
    icon: 'cil-puzzle',
  },
  {
    component: 'CNavTitle',
    name: 'Adjust Reports',
  },
  {
    component: 'CNavItem',
    name: 'Raw Data',
    to: '/adjust/raw-report',
    icon: 'cib-libreoffice',
  },
  {
    component: 'CNavItem',
    name: 'Ad Name Week',
    to: '/adjust/group-ad-name-report',
    icon: 'cib-libreoffice',
  },
  {
    component: 'CNavItem',
    name: 'Ad Name Month',
    to: '/adjust/group-ad-name-month-report',
    icon: 'cib-libreoffice',
  },
  {
    component: 'CNavItem',
    name: 'Code Week',
    to: '/adjust/group-code-week-report',
    icon: 'cib-libreoffice',
  },
  {
    component: 'CNavItem',
    name: 'Code Day',
    to: '/adjust/group-code-day-report',
    icon: 'cib-libreoffice',
  },
  {
    component: 'CNavItem',
    name: 'Code Month',
    to: '/adjust/group-code-month-report',
    icon: 'cib-libreoffice',
  },
  {
    component: 'CNavItem',
    name: 'Code Month VID',
    to: '/adjust/group-code-month-vid-report',
    icon: 'cib-libreoffice',
  },
  {
    component: 'CNavItem',
    name: 'Code Month PL',
    to: '/adjust/group-code-month-pl-report',
    icon: 'cib-libreoffice',
  },

]
